import { render } from "./FormSwitch.vue?vue&type=template&id=aa60acf4&ts=true"
import script from "./FormSwitch.vue?vue&type=script&lang=ts"
export * from "./FormSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__